const isLogIn = (navigate) => {
    if(localStorage.getItem("token")){
        navigate('/'); 
    }
}

export default isLogIn;